import React from 'react';
import './FormSuccessMessage.scss';
import Owl from '../../Graphics/Owl';
import { COLORS } from '../../../../constants/colors';

/**
 * Renders Form success message
 * @param title
 * @param message
 * @returns {JSX.Element}
 * @constructor
 */
const FormSuccessMessage = ({ title, message }) => (
  <div className="c-form-success-message">
    <div className="c-form-success-message__title h2-roobert">
      <h2>{title}</h2>
    </div>
    <div className="c-form-success-message__message body-1">
      <p>{message}</p>
    </div>
    <div className="c-form-success-message__owl-container">
      <Owl color={COLORS.black} />
    </div>
  </div>
);

export default FormSuccessMessage;
